// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes eenJeoBmpKhNjl {
  0% {
    background-position: 0%;
  }

  50% {
    background-position: 100%;
  }

  100% {
    background-position: 0%;
  }
}

.x0Kmc14dIqr0zB {
  opacity: .3;
  background: linear-gradient(90deg, #1868db, #af59e0, #ffa200, #5c9c00, #af59e0, #1868db) 0 0 / 300% 300%;
  animation: 3s infinite eenJeoBmpKhNjl;
}

@media (prefers-reduced-motion: reduce) {
  .x0Kmc14dIqr0zB {
    animation: none;
  }
}
`, ""]);
// Exports
export var aiLoadingGradient = `x0Kmc14dIqr0zB`;
export var aiLoadingGradientRotate = `eenJeoBmpKhNjl`;
export default ___CSS_LOADER_EXPORT___;
